const header = (() => {

    const initBlock = el => {
        header.scope = el;
        header.topLevelNavLinks = el.querySelectorAll('[data-mega-nav-toggle]');
        header.mobileBurger = el.querySelector("[data-header-burger]");
        header.mobileMenu = el.querySelector("[data-header-second-nav]");
        header.mobileNavOpen = false;
        header.backButtons = el.querySelectorAll('[data-back-button]');
        header.toggleSearch = el.querySelector("[data-search-toggle]");
        header.search = el.querySelector("[data-header-search]");
        header.searchInput = el.querySelector('input[type="search"]');
        header.enquiryToggle = el.querySelector("[data-enquiry-toggle]");
        header.enquiryDropDown = el.querySelector("[data-enquiry-list]");
        header.currentLink = null;
        bindEvents(el);
    };

    const bindEvents = () => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    if (header.search.classList.contains('hidden')) {
                        closeSearch();
                    } else {
                        openSearch();
                    }
                    if (header.enquiryDropDown.classList.contains('hidden')) {
                        closeEnquiry();
                    } else {
                        openEnquiry();
                    }
                }
            });
        });

        observer.observe(header.search, { attributes: true });
        observer.observe(header.enquiryDropDown, { attributes: true });

        header.topLevelNavLinks.forEach(link => {
            link.addEventListener("click", () => {
                const nav = getNav(link);
                if (nav.classList.contains("block")) {
                    closeNav(nav);
                } else {
                    closeAllNavs();
                    openNav(nav, link);
                }
            });
        });
        header.mobileBurger.addEventListener("click", () => {
            if(header.mobileNavOpen){
                closeMobileNav();
            }else{
                setTimeout(()=>{
                    openMobileNav();    
                }, 0);
                
            }
        });
        header.backButtons.forEach(link => {
            link.addEventListener("click", e => {
                link.closest("[data-header-third-nav]").classList.add("hidden");
            });
        });
    };
    const openEnquiry = () => {
        document.addEventListener('click', handleOutsideEnquiryClick);
        document.addEventListener('keyup', handleOutsideEnquiryKeyup);
    };

    const closeEnquiry = () => {
        document.removeEventListener('click', handleOutsideEnquiryClick);
        document.removeEventListener('keyup', handleOutsideEnquiryKeyup);
    };

    const handleOutsideEnquiryClick = event => {
        if (!header.enquiryDropDown.contains(event.target) && !header.enquiryToggle.contains(event.target)) {
           header.enquiryToggle.click();
        }
        if(event.target.closest("[data-search-toggle]") !== null){
            setTimeout(()=>{
                header.toggleSearch.click();
            })
        }
    };

    const handleOutsideEnquiryKeyup = event => {
        if (event.key === 'Escape' || (!header.enquiryDropDown.contains(event.target) && !header.enquiryToggle.contains(event.target))) {
            header.enquiryToggle.click();
        }
    };
    
    const openSearch = () =>{
        const searchIcons = header.toggleSearch.querySelectorAll("span");
        searchIcons[1].classList.remove("hidden");
        searchIcons[0].classList.add("hidden");
        header.searchInput.focus();
    }
    const closeSearch = () =>{
        const searchIcons = header.toggleSearch.querySelectorAll("span");
        searchIcons[0].classList.remove("hidden");
        searchIcons[1].classList.add("hidden");
    }
    const closeMobileNav = () => {
        header.mobileMenu.classList.add("hidden");
        header.mobileNavOpen = false;
        toggleBurgerIcons();
        document.removeEventListener('click', handleOutsideMobileClick);
    };

    const openMobileNav = () => {
        header.mobileMenu.classList.remove("hidden");
        header.mobileNavOpen = true;
        toggleBurgerIcons();
        document.addEventListener('click', handleOutsideMobileClick);
    };

    const toggleBurgerIcons = () => {
        header.mobileBurger.querySelectorAll("span").forEach(icon => icon.classList.toggle("hidden"));
    };

    const closeNav = nav => {
        nav.classList.remove("block");
        nav.classList.add("hidden");
        document.removeEventListener('click', handleOutsideMenuClick);
        nav.removeEventListener('focusout', handleFocusOut);
    };

    const openNav = (nav, link) => {
        nav.classList.add("block");
        nav.classList.remove("hidden");
        nav.focus();
           document.addEventListener('click', handleOutsideMenuClick);
           nav.addEventListener('focusout', handleFocusOut);
           header.currentNav = nav;
           header.currentLink = link;
    };

    const closeAllNavs = () => {
        header.topLevelNavLinks && header.topLevelNavLinks.forEach(link => {
            closeNav(getNav(link));
        });
    };

    const getNav = link => {
        return link.parentNode.children[1];
    };

    const handleOutsideMenuClick = event => {
        setTimeout(() => {
            if (header.currentNav && !header.currentNav.contains(event.target) && !header.currentLink.contains(event.target)) {
                closeNav(header.currentNav);
            }
        })
       
    };

    const handleFocusOut = event => {
        setTimeout(() => {
            if (header.currentNav && !header.currentNav.contains(document.activeElement) && !header.currentLink.contains(document.activeElement)) {
                closeNav(header.currentNav);
            }
        }, 0);
    };

    const handleOutsideMobileClick = event => {
        if (header.mobileNavOpen && !header.mobileMenu.contains(event.target) && !header.mobileBurger.contains(event.target)) {
            closeMobileNav();
        }
    };
    

    return { initBlock };
})();

document.querySelectorAll('[data-header]').forEach(el => header.initBlock(el));
